module.exports = __webpack_public_path__ + "static/Face-Simon.8fed9958.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Face-Simon.jpg
// module id = 492
// module chunks = 144251824217401